<template>

    <div class="row">

        <div class="col-md-12 co-12">
            <b-card title="Búsqueda">

                <b-row>


                    <b-col md="6" xl="4">

                        <label >Desde</label>
                        <b-input-group class="mb-1">
                            <b-form-input id="txtFechaDesde" v-model="txtFechaDesde" type="text"
                                placeholder="YYYY-MM-DD" autocomplete="off" show-decade-nav />
                            <b-input-group-append>
                                <b-form-datepicker v-model="txtFechaDesde" show-decade-nav button-only right
                                    locale="es-ES" aria-controls="txtFechaDesde" size="sm" />
                            </b-input-group-append>
                        </b-input-group>

                    </b-col>


                    <b-col md="6" xl="4">
                        <label >Hasta</label>
                        <b-input-group class="mb-1">
                            <b-form-input id="txtFechaHasta" v-model="txtFechaHasta" type="text"
                                placeholder="YYYY-MM-DD" autocomplete="off" show-decade-nav />
                            <b-input-group-append>
                                <b-form-datepicker v-model="txtFechaHasta" show-decade-nav button-only right
                                    locale="es-ES" aria-controls="txtFechaHasta" size="sm" />
                            </b-input-group-append>
                        </b-input-group>
                    </b-col>


                    <b-col md="6" xl="4">
                        <b-form-group label="Empresa" label-for="empresa">
                            <b-form-select v-model="selectedEmpresa" :options="optionsEmpresa"
                                v-on:change="mostrarCultivoFiltro()" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6" xl="4">
                        <b-form-group label="Cultivo" label-for="Cultivo">
                            <b-form-select v-model="selectedCultivo" :options="optionsCultivo"
                                v-on:change="mostrarFundoFiltro()" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6" xl="4">
                        <b-form-group label="Fundo" label-for="Fundo">
                            <b-form-select v-model="selectedFundo" :options="optionsFundo"
                                v-on:change="mostrarLugarFiltro()" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6" xl="4">
                        <b-form-group label="Lugar" label-for="Lugar">
                            <b-form-select v-model="selectedLugar" :options="optionsLugar" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6" xl="4">
                        <b-form-group label="Categoria" label-for="categoria">
                            <b-form-select v-model="selectedCategoria" :options="optionsCategoria" />
                        </b-form-group>
                    </b-col>

                    <b-col md="6" xl="4">
                        <b-form-group label="Estado" label-for="estado">
                            <b-form-select v-model="selectedEstado" :options="optionsEstado" />
                        </b-form-group>
                    </b-col>

                    <!-- block -->
                    <b-col md="6" xl="4">
                        <div class="demo-inline-spacing">
                            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                                v-on:click="filtrarGraficos()">
                                Filtrar
                            </b-button>
                        </div>
                    </b-col>


                </b-row>

            </b-card>

            <div class="row">

                <div class="col-md-12 co-12">

                </div>

                <div class="col-md-6 co-6">
                    <b-card title="Cantidad de Trabajadores Sancionados por Mes (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresSanc">

                        </div>

                    </b-card>

                    <b-card title="Cantidad de Trabajadores Sancionados por Area y Departamento (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresSancXArea">

                        </div>

                    </b-card>

                    <b-card title="Cantidad de Trabajadores Sancionados por Tipo de Sanción (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresSancXTipoSancion">

                        </div>

                    </b-card>

                    <b-card title="Cantidad de Trabajadores Amonestados por Motivo (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresAmonXMotivo">

                        </div>

                    </b-card>

                    <b-card title="Cantidad de Trabajadores Suspendidos por Motivo (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresSuspXMotivo">

                        </div>

                    </b-card>

                </div>

                <div class="col-md-6 co-6">
                    <b-card title="Cantidad de Trabajadores Sancionados por Semana y Mes (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresSancXSemMes">

                        </div>

                    </b-card>

                    <b-card title="Cantidad de Trabajadores Sancionados por Sección y Area (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresSancXSeccionYArea">

                        </div>

                    </b-card>

                    <b-card
                        title="Cantidad de Trabajadores Sancionados por Tipo de Sanción por Departamento (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresSancXTipoSancionXDepartamento">

                        </div>

                    </b-card>

                    <b-card
                        title="Cantidad de Trabajadores Amonestados por Departamento por Motivo (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresAmonXDepartamentoXMotivo">

                        </div>

                    </b-card>

                    <b-card
                        title="Cantidad de Trabajadores Suspendidos por Departamento por Motivo (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresSuspXDepartamentoXMotivo">

                        </div>

                    </b-card>
                </div>

                <div class="col-md-12 co-12">

                    <b-card title="Cantidad de Trabajadores Amonestados por Motivo por Semana (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresAmonXMotivoXSem">

                        </div>

                    </b-card>

                    <b-card title="Cantidad de Trabajadores Suspendidos por Motivo por Semana (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresSuspXMotivoXSem">

                        </div>

                    </b-card>

                    <b-card title="Cantidad de Trabajadores Sancionados por Usuario que Reporta (Fecha de Creación)">

                        <div class="size_grafico" ref="cantTrabajadoresSancXUsuarioReporta">

                        </div>

                    </b-card>




                </div>
            </div>

        </div>

    </div>

</template>

<script>
import axios from 'axios'
import axiosIns from '../../../libs/axios'
import {
    BCard, BButton, BRow, BCol, BFormGroup, BInputGroupPrepend, BInputGroup, BFormDatepicker,
    BFormInput, BInputGroupAppend, BFormSelect, BTable, BPagination, BBadge, BCardText,
    BSpinner, BForm, BAvatar, BTabs, BTab, BFormFile, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import moment from 'moment'
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

export default {
    components: {
        BCard, BButton, BRow, BCol, BFormGroup, BInputGroupPrepend, BInputGroup, BFormDatepicker,
        BFormInput, BInputGroupAppend, BFormSelect, BTable, BPagination, BBadge, BCardText,
        BSpinner, BForm, BAvatar, BTabs, BTab, BFormFile, BListGroup, BListGroupItem,
        vSelect
    },
    directives: {
        Ripple,
    },
    data() {
        return {

            txtFechaDesde: moment().format('YYYY-MM-DD'),
            txtFechaHasta: moment().format('YYYY-MM-DD'),

            selectedEmpresa: null,
            optionsEmpresa: [],

            selectedCultivo: 'TODOS',
            optionsCultivo: [],

            selectedFundo: 'TODOS',
            optionsFundo: [],

            selectedLugar: 'TODOS',
            optionsLugar: [],

            selectedCategoria: 'TODAS',
            optionsCategoria: [],

            selectedEstado: 'TODOS',
            optionsEstado: [],

            key_empresa_sap: '',

            optionCultivosNoCampo: [],

            zonas: [],

            dataGraficoCantTrabSancionados: [],
            dataGraficoCantTrabSancionadosXSemMes: [],

            rootGraficoCantTrabSancionados: [],
            rootGraficoCantTrabSancionadosXSemMes: [],
            rootGraficoCantTrabSancionadosXArea: [],
            rootGraficoCantTrabSancionadosXSeccionYArea: [],
            rootGraficoCantTrabSancionadosXTipoSancion: [],
            rootGraficoCantTrabSancionadosXTipoSancionXDepartamento: [],
            rootGraficoCantTrabAmonestadosXMotivo: [],
            rootGraficoCantTrabAmonestadosXDepartamentoXMotivo: [],
            rootGraficoCantTrabSuspendidosXMotivo: [],
            rootGraficoCantTrabSuspendidosXDepartamentoXMotivo: [],
            rootGraficoCantTrabAmonestadosXMotivoXSemana: [],
            rootGraficoCantTrabSuspendidosXMotivoXSemana: [],
            rootGraficoCantTrabSuspendidosXUsuarioReporta: [],

        }

    },
    methods: {

        obtenerCategorias() {
            this.optionsCategoria = [];
            const arrayCategoria = [];

            const config = {
                method: 'get',
                url: '/sap/md/categoria/list/',
            };

            axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        let optionsTemporal = response.data;
                        arrayCategoria.push({ value: 'TODAS', text: 'TODAS' });

                        optionsTemporal.filter((item) => {
                            arrayCategoria.push({ value: item.id, text: item.descripcion });
                        });

                        this.optionsCategoria = arrayCategoria;

                    }
                    //console.log(JSON.stringify(response.data));
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= obtenerCategorias");
                    // this.obtenerCategorias();
                });
        },
        obtenerEstados() {
            this.optionsEstado = [];
            const arrayEstado = [];
            arrayEstado.push({ value: 'TODOS', text: 'TODOS' });

          const config = {
            method: 'get',
            url: '/sap/md/mdestadosancion/list/',
          }

          axiosIns(config).then((response) => {

                if (response.status === 200) {
                    let optionsTemporal = response.data;

                    optionsTemporal.filter((item) => {
                        arrayEstado.push({ value: item.id, text: item.descripcion });
                    });

                    this.optionsEstado = arrayEstado;

                }

            }).catch((error) => {
                //console.log(error);
                console.log("=======error======= obtenerEstados");
                // this.obtenerEstados();
            });

        },
        obtenerEmpresa() {
            const valor = JSON.parse(localStorage.getItem('userData'));

          const config = {
            method: 'get',
            url: '/sap/md/getPersonal/?dni=' + valor.dni,
          }

          axios(config)
                .then((response) => {
                    if (response.status === 200) {
                        if (response.data.status === true) {
                            const order = 1;
                            const trabajador = response.data.response;

                            if (trabajador.length !== 0) {
                                trabajador.sort((a, b) => {
                                    a = new Date(a.fecha_ingreso);
                                    b = new Date(b.fecha_ingreso);
                                  const results = a > b ? -1 : a < b ? 1 : 0
                                  return results * order;
                                });
                                this.key_empresa_sap = trabajador[0].key_empresa_sap;
                            }

                        }

                    }

                })
                .catch((error) => {
                    console.log(error);
                    console.log("=======error======= obtenerEmpresa");
                    //this.obtenerEmpresa();
                })
                .finally(() => {
                    this.mostrarSelectEmpresa()
                    //this.obtenerTrabajadores()
                });
        },
        obtenerTrabajadores() {
            this.optionCultivosNoCampo = [];

          const config = {
            method: 'get',
            url: '/sap/md/getPersonal/',
            // headers: {
            //   'Authorization': 'Basic YXBsaWNhY2lvbmVzX2dldDopdzFuNE1wKiVzdFIxazMmIw=='
            // }
          }

          axios(config)
                .then((response) => {
                    if (response.status === 200) {
                        if (response.data.status === true) {

                            const trabajadores = response.data.response;

                            trabajadores.filter((item) => {
                                if (item.nombre_cargo !== 'OBRERO AGRARIO' && item.seccion !== '' && item.key_empresa_sap === this.key_empresa_sap) {
                                    if (this.optionCultivosNoCampo.findIndex(element => element.value === item.seccion) === -1) {
                                        this.optionCultivosNoCampo.push({ value: item.seccion, text: item.seccion });
                                    }
                                }
                            });

                            this.optionCultivosNoCampo.sort((a, b) => {
                                const valueA = a.value.toUpperCase(); // ignore upper and lowercase
                                const valueB = b.value.toUpperCase(); // ignore upper and lowercase
                                if (valueA < valueB) {
                                    return -1;
                                }
                                if (valueA > valueB) {
                                    return 1;
                                }
                                return 0;
                            });

                        }

                    }

                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= obtenerTrabajadores");
                    //this.obtenerTrabajadores();
                })
                .finally(() => {
                    this.mostrarCultivoFiltro();
                });
        },
        mostrarSelectEmpresa() {
            if (this.key_empresa_sap === "PE10") { //AGROVISION
                this.selectedEmpresa = 'AGROVISIÓN PERÚ S.A.C'
                this.optionsEmpresa = [
                    { value: 'AGROVISIÓN PERÚ S.A.C', text: 'AGROVISIÓN PERÚ S.A.C' },
                ]
            }

            if (this.key_empresa_sap === "PE20") { //ARENA VERDE
                this.selectedEmpresa = 'ARENA VERDE'
                this.optionsEmpresa = [
                    { value: 'ARENA VERDE', text: 'ARENA VERDE' },
                ]
            }
            this.mostrarCultivoFiltro();

        },
        obtenerZonas() {
            this.zonas = [];

          const config = {
            method: 'get',
            url: '/pagricolas/data_lineal/',
            headers: {}
          }

          axios(config)
                .then((response) => {
                    if (response.status === 200) {
                        this.zonas = response.data;
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= obtenerZonas");
                    //this.obtenerZonas();
                })
                .finally(() => {
                    this.mostrarCultivoFiltro();
                });
        },
        mostrarCultivoFiltro() {
            this.selectedCultivo = 'TODOS';
            this.optionsCultivo = [];

            this.selectedFundo = 'TODOS';
            this.optionsFundo = [];

            this.selectedLugar = 'TODOS';
            this.optionsLugar = [];

            const optionsCultivoTemp = [];

            this.optionsCultivo.push({ value: 'TODOS', text: 'TODOS' });

            this.zonas.filter((item) => {
                if (item.sociedad === this.selectedEmpresa) {
                    if (optionsCultivoTemp.indexOf(item.cultivo) < 0) {
                        optionsCultivoTemp.push(item.cultivo);
                        this.optionsCultivo.push({ value: item.cultivo, text: item.cultivo });
                    }
                }
            });

            if (this.key_empresa_sap === 'PE20') {
                this.optionsCultivo = this.optionCultivosNoCampo;
            }

            this.mostrarFundoFiltro();

        },
        mostrarFundoFiltro() {
            this.selectedFundo = 'TODOS';
            this.optionsFundo = [];

            this.selectedLugar = 'TODOS';
            this.optionsLugar = [];

            const optionsFundoTemp = [];

            this.optionsFundo.push({ value: 'TODOS', text: 'TODOS' });

            this.zonas.filter((item) => {
                if (item.sociedad === this.selectedEmpresa && item.cultivo === this.selectedCultivo) {
                    if (optionsFundoTemp.indexOf(item.fundo) < 0) {
                        optionsFundoTemp.push(item.fundo);
                        this.optionsFundo.push({ value: item.fundo, text: item.fundo });
                    }
                }
            });

            this.mostrarLugarFiltro();
        },
        mostrarLugarFiltro() {

            this.selectedLugar = 'TODOS';
            this.optionsLugar = [];

            if (this.key_empresa_sap === "PE10") { //AGROVISION
                this.optionsLugar = [
                    { value: 'TODOS', text: 'TODOS' },
                    { value: 'CAMPO', text: 'CAMPO' },
                    { value: 'Packing Grande', text: 'Packing Grande' },
                ]

                if (this.selectedCultivo === "ARANDANO") {
                    this.optionsLugar = [];
                    this.optionsLugar = [
                        { value: 'TODOS', text: 'TODOS' },
                        { value: 'CAMPO', text: 'CAMPO' },
                        { value: 'Packing Grande', text: 'Packing Grande' },
                        { value: 'Packing A9', text: 'Packing A9' },
                    ]
                }
                if (this.selectedCultivo === "ESPÁRRAGO") {
                    this.optionsLugar = [];
                    this.optionsLugar = [
                        { value: 'TODOS', text: 'TODOS' },
                        { value: 'CAMPO', text: 'CAMPO' },
                        { value: 'Packing Esparrago', text: 'Packing Esparrago' },
                    ]
                }
            }

            if (this.key_empresa_sap === "PE20") { //ARENA VERDE
                this.optionsLugar = [
                    { value: 'TODOS', text: 'TODOS' },
                    { value: 'CAMPO', text: 'CAMPO' },
                ]
            }
            //this.obtenerSanciones();
        },
        filtrarGraficos() {
            this.graficoCantTrabSancionados();
            this.graficoCantTrabSancionadosXSemMes();
            this.graficoCantTrabSancionadosXArea();
            this.graficoCantTrabSancionadosXSeccionYArea();
            this.graficoCantTrabSancionadosXTipoSancion();
            this.graficoCantTrabSancionadosXTipoSancionXDepartamento();
            this.graficoCantTrabAmonestadosXMotivo();
            this.graficoCantTrabAmonestadosXDepartamentoXMotivo();
            this.graficoCantTrabSuspendidosXMotivo();
            this.graficoCantTrabSuspendidosXDepartamentoXMotivo();
            this.graficoCantTrabAmonestadosXMotivoXSemana();
            this.graficoCantTrabSuspendidosXMotivoXSemana();
            this.graficoCantTrabSuspendidosXUsuarioReporta();
        },
        graficoCantTrabSancionados() {
            if (typeof this.rootGraficoCantTrabSancionados == "object") {
                this.rootGraficoCantTrabSancionados = [];
            }
            this.dataGraficoCantTrabSancionados = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancxtrab/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        this.dataGraficoCantTrabSancionados = response.data.response;

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresSanc);

                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);

                        let chart = rootTemp.container.children.push(am5xy.XYChart.new(rootTemp, {
                            panX: true,
                            panY: true,
                            wheelX: "panX",
                            wheelY: "zoomX",
                            pinchZoomX: true
                        }));

                        let cursor = chart.set("cursor", am5xy.XYCursor.new(rootTemp, {}));
                        cursor.lineY.set("visible", false);

                        let xRenderer = am5xy.AxisRendererX.new(rootTemp, { minGridDistance: 30 });
                        xRenderer.labels.template.setAll({
                            rotation: -90,
                            centerY: am5.p50,
                            centerX: am5.p100,
                            paddingRight: 15
                        });

                        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(rootTemp, {
                            maxDeviation: 0.3,
                            categoryField: "nom_mes",
                            renderer: xRenderer,
                            tooltip: am5.Tooltip.new(rootTemp, {})
                        }));

                        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(rootTemp, {
                            maxDeviation: 0.3,
                            renderer: am5xy.AxisRendererY.new(rootTemp, {})
                        }));

                        let series = chart.series.push(am5xy.ColumnSeries.new(rootTemp, {
                            name: "Series 1",
                            xAxis: xAxis,
                            yAxis: yAxis,
                            valueYField: "value",
                            sequencedInterpolation: true,
                            categoryXField: "nom_mes",
                            tooltip: am5.Tooltip.new(rootTemp, {
                                labelText: "{valueY}"
                            })
                        }));

                        series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5 });
                        /*series.columns.template.adapters.add("fill", function (fill, target) {
                            return chart.get("colors").getIndex(series.columns.indexOf(target));
                        });

                        series.columns.template.adapters.add("stroke", function (stroke, target) {
                            return chart.get("colors").getIndex(series.columns.indexOf(target));
                        });*/

                        series.set("fill", am5.color("#134D25"));
                        series.set("stroke", am5.color("#134D25"));

                        // Add Label bullet
                        series.bullets.push(function () {
                            return am5.Bullet.new(rootTemp, {
                                locationY: 1,
                                sprite: am5.Label.new(rootTemp, {
                                text: "{valueYWorking.formatNumber('#.')}",
                                fill: rootTemp.interfaceColors.get("alternativeText"),
                                centerY: 0,
                                centerX: am5.p50,
                                populateText: true
                                })
                            });
                        });

                        chart.set(
                            "scrollbarX",
                            am5.Scrollbar.new(rootTemp, {
                                orientation: "horizontal"
                            })
                        );

                        xAxis.data.setAll(this.dataGraficoCantTrabSancionados);
                        series.data.setAll(this.dataGraficoCantTrabSancionados);

                        series.appear(1000);
                        chart.appear(1000, 100);



                        rootTemp._logo.dispose();
                        this.rootGraficoCantTrabSancionados = rootTemp;


                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionados");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },
        graficoCantTrabSancionadosXSemMes() {
            if (this.rootGraficoCantTrabSancionadosXSemMes !== "") {
                this.rootGraficoCantTrabSancionadosXSemMes = [];
            }
            this.dataGraficoCantTrabSancionadosXSemMes = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancxtrabxmessemana/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        //this.$refs.cantTrabajadoresSancXSemMes
                        //const dataGraficoCantTrabSancionadosXSemMesTemp = response.data.response;

                        //console.log(dataGraficoCantTrabSancionadosXSemMesTemp);

                        /*var nuevoArray = []
                        var arrayTemporal = []
                        for (var i = 0; i < dataGraficoCantTrabSancionadosXSemMesTemp.length; i++) {
                            arrayTemporal = nuevoArray.filter(resp => resp["nro_semana"] == dataGraficoCantTrabSancionadosXSemMesTemp[i]["nom_mes"])

                            if (arrayTemporal.length > 0) {
                            console.log("ingresoooooooooo");
                            nuevoArray[nuevoArray.indexOf(arrayTemporal[0])]["Profesionales"].push(dataGraficoCantTrabSancionadosXSemMesTemp[i]["nro_semana"])

                            } else {
                            nuevoArray.push({ "nro_semana": dataGraficoCantTrabSancionadosXSemMesTemp[i]["nom_mes"], "Profesionales": [dataGraficoCantTrabSancionadosXSemMesTemp[i]["nro_semana"]] })
                            console.log(dataGraficoCantTrabSancionadosXSemMesTemp[i]["nro_semana"]);
                            var inde = dataGraficoCantTrabSancionadosXSemMesTemp[i]["nro_semana"];
                            nuevoArray[dataGraficoCantTrabSancionadosXSemMesTemp[i]["nom_mes"]] = {
                                inde : 5
                            }
                            nuevoArray[dataGraficoCantTrabSancionadosXSemMesTemp[i]["nom_mes"]] = {}
                            nuevoArray[dataGraficoCantTrabSancionadosXSemMesTemp[i]["nom_mes"]][dataGraficoCantTrabSancionadosXSemMesTemp[i]["nro_semana"]] = [dataGraficoCantTrabSancionadosXSemMesTemp[i]["cant"]]

                            var config = {
                                method: 'post',
                                url: '/sap/md/mdsancion/crear/',
                                data: 'data'
                            };

                            nuevoArray[dataGraficoCantTrabSancionadosXSemMesTemp[i]["nom_mes"]] = config;
                        }

                        console.log(nuevoArray["Enero"]);*/

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresSancXSemMes);

                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);

                        let chart = rootTemp.container.children.push(
                            am5xy.XYChart.new(rootTemp, {
                                panX: false,
                                panY: false,
                                wheelX: "none",
                                wheelY: "none"
                            })
                        );

                        let cursor = chart.set("cursor", am5xy.XYCursor.new(rootTemp, {}));
                        cursor.lineY.set("visible", false);

                        let xRenderer = am5xy.AxisRendererX.new(rootTemp, { minGridDistance: 30 });
                        xRenderer.labels.template.setAll({ text: "{realName}" });

                        let xAxis = chart.xAxes.push(
                            am5xy.CategoryAxis.new(rootTemp, {
                                maxDeviation: 0,
                                categoryField: "category",
                                renderer: xRenderer,
                                tooltip: am5.Tooltip.new(rootTemp, {
                                    labelText: "{realName}"
                                })
                            })
                        );

                        let yAxis = chart.yAxes.push(
                            am5xy.ValueAxis.new(rootTemp, {
                                maxDeviation: 0.3,
                                renderer: am5xy.AxisRendererY.new(rootTemp, {})
                            })
                        );

                        let yAxis2 = chart.yAxes.push(
                            am5xy.ValueAxis.new(rootTemp, {
                                maxDeviation: 0.3,
                                syncWithAxis: yAxis,
                                renderer: am5xy.AxisRendererY.new(rootTemp, { opposite: true })
                            })
                        );

                        let series = chart.series.push(
                            am5xy.ColumnSeries.new(rootTemp, {
                                name: "Series 1",
                                xAxis: xAxis,
                                yAxis: yAxis2,
                                valueYField: "value",
                                sequencedInterpolation: true,
                                categoryXField: "category",
                                tooltip: am5.Tooltip.new(rootTemp, {
                                    labelText: "{provider} {realName}: {valueY}"
                                })
                            })
                        );

                        series.columns.template.setAll({
                            fillOpacity: 0.9,
                            strokeOpacity: 0
                        });

                        series.set("fill", am5.color("#134D25"));
                        series.set("stroke", am5.color("#134D25"));

                        // Add Label bullet
                        series.bullets.push(function () {
                            return am5.Bullet.new(rootTemp, {
                                locationY: 1,
                                sprite: am5.Label.new(rootTemp, {
                                text: "{valueYWorking.formatNumber('#.')}",
                                fill: rootTemp.interfaceColors.get("alternativeText"),
                                centerY: 0,
                                centerX: am5.p50,
                                populateText: true
                                })
                            });
                        });

                        chart.set(
                            "scrollbarX",
                            am5.Scrollbar.new(rootTemp, {
                                orientation: "horizontal"
                            })
                        );

                        let chartData = [];

                        let data = {
                            "Enero": {
                                "1": 2
                            },
                            "Marzo": {
                                "10": 15
                            },
                            "Mayo": {
                                "18": 1,
                                "20": 3
                            },
                            "Noviembre": {
                                "45": 1
                            }
                        };



                        for (let providerName in data) {
                            let providerData = data[providerName];

                            let tempArray = [];

                            for (let itemName in providerData) {
                                tempArray.push({
                                    category: providerName + "_" + itemName,
                                    realName: itemName,
                                    value: providerData[itemName],
                                    provider: providerName
                                });
                            }



                            am5.array.each(tempArray, function (item) {
                                chartData.push(item);
                            });

                            let range = xAxis.makeDataItem({});
                            xAxis.createAxisRange(range);

                            range.set("category", tempArray[0].category);
                            range.set("endCategory", tempArray[tempArray.length - 1].category);

                            let label = range.get("label");

                            label.setAll({
                                text: tempArray[0].provider,
                                dy: 30,
                                fontWeight: "bold",
                                tooltipText: tempArray[0].provider
                            });

                            let tick = range.get("tick");
                            tick.setAll({ visible: true, strokeOpacity: 1, length: 50, location: 0 });

                            let grid = range.get("grid");
                            grid.setAll({ strokeOpacity: 1 });
                        }

                        // add range for the last grid
                        let range = xAxis.makeDataItem({});
                        xAxis.createAxisRange(range);
                        range.set("category", chartData[chartData.length - 1].category);
                        let tick = range.get("tick");
                        tick.setAll({ visible: true, strokeOpacity: 1, length: 50, location: 1 });

                        let grid = range.get("grid");
                        grid.setAll({ strokeOpacity: 1, location: 1 });

                        xAxis.data.setAll(chartData);
                        series.data.setAll(chartData);

                        // Make stuff animate on load
                        // https://www.amcharts.com/docs/v5/concepts/animations/
                        series.appear(1000);
                        chart.appear(1000, 100);

                        rootTemp._logo.dispose();
                        this.rootGraficoCantTrabSancionadosXSemMes = rootTemp;


                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionadosXSemMes");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },
        graficoCantTrabSancionadosXArea() {
            if (this.rootGraficoCantTrabSancionadosXArea !== "") {
                this.rootGraficoCantTrabSancionadosXArea = [];
            }
            this.dataGraficoCantTrabSancionados = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/canttrabsancionadosxarea/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        //this.dataGraficoCantTrabSancionados = response.data.response;

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresSancXArea);

                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);


                        // Create chart
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/
                        let chart = rootTemp.container.children.push(am5xy.XYChart.new(rootTemp, {
                            panX: false,
                            panY: false,
                            wheelX: "panX",
                            wheelY: "zoomX",
                            layout: rootTemp.verticalLayout
                        }));


                        // Add legend
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
                        let legend = chart.children.push(
                            am5.Legend.new(rootTemp, {
                                centerX: am5.p50,
                                x: am5.p50
                            })
                        );

                        let data = [{
                            "year": "4 - UN ARÁNDANO",
                            "europe": 2,
                            "namerica": 1,
                            "asia": 2.1,
                            "lamerica": 1,
                            "meast": 0.8,
                            "africa": 0.4
                        }, {
                            "year": "7 - PACKING",
                            "europe": 4,
                            "namerica": 1,
                            "asia": 2.2,
                            "lamerica": 0.5,
                            "meast": 0.4,
                            "africa": 0.3
                        }]


                        // Create axes
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
                        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(rootTemp, {
                            categoryField: "year",
                            renderer: am5xy.AxisRendererX.new(rootTemp, {
                                cellStartLocation: 0.1,
                                cellEndLocation: 0.9
                            }),
                            tooltip: am5.Tooltip.new(rootTemp, {})
                        }));

                        xAxis.data.setAll(data);

                        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(rootTemp, {
                            renderer: am5xy.AxisRendererY.new(rootTemp, {})
                        }));


                        // Add series
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
                        function makeSeries(name, fieldName) {
                            let series = chart.series.push(am5xy.ColumnSeries.new(rootTemp, {
                                name: name,
                                xAxis: xAxis,
                                yAxis: yAxis,
                                valueYField: fieldName,
                                categoryXField: "year"
                            }));

                            series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5 });

                            series.set("fill", am5.color("#134D25"));
                            series.set("stroke", am5.color("#134D25"));

                            series.bullets.push(function () {
                                return am5.Bullet.new(rootTemp, {
                                    locationY: 1,
                                    sprite: am5.Label.new(rootTemp, {
                                    text: "{valueYWorking.formatNumber('#.')}",
                                    fill: rootTemp.interfaceColors.get("alternativeText"),
                                    centerY: 0,
                                    centerX: am5.p50,
                                    populateText: true
                                    })
                                });
                            });

                            series.columns.template.setAll({
                                tooltipText: "{name}, {categoryX}:{valueY}",
                                width: am5.percent(90),
                                tooltipY: 0
                            });

                            series.data.setAll(data);

                            // Make stuff animate on load
                            // https://www.amcharts.com/docs/v5/concepts/animations/
                            series.appear();

                            series.bullets.push(function () {
                                return am5.Bullet.new(rootTemp, {
                                    locationY: 0,
                                    sprite: am5.Label.new(rootTemp, {
                                        text: "{valueY}",
                                        fill: rootTemp.interfaceColors.get("alternativeText"),
                                        centerY: 0,
                                        centerX: am5.p50,
                                        populateText: true
                                    })
                                });
                            });

                            legend.data.push(series);
                        }

                        makeSeries("9 - OPERACIONES AGRÍCOLAS", "europe");
                        makeSeries("6 - INNOVACIÓN Y NUEVOS NEGOCIOS", "namerica");
                        /*makeSeries("Asia", "asia");
                        makeSeries("Latin America", "lamerica");
                        makeSeries("Middle East", "meast");
                        makeSeries("Africa", "africa");*/

                        chart.set(
                            "scrollbarX",
                            am5.Scrollbar.new(rootTemp, {
                                orientation: "horizontal"
                            })
                        );


                        // Make stuff animate on load
                        // https://www.amcharts.com/docs/v5/concepts/animations/
                        chart.appear(1000, 100);

                        rootTemp._logo.dispose();

                        this.rootGraficoCantTrabSancionadosXArea = rootTemp;
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionados");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },
        graficoCantTrabSancionadosXSeccionYArea() {
            if (this.rootGraficoCantTrabSancionadosXSeccionYArea !== "") {
                this.rootGraficoCantTrabSancionadosXSeccionYArea = [];
            }
            //this.dataGraficoCantTrabSancionados = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancxtrab/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        //this.dataGraficoCantTrabSancionados = response.data.response;

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresSancXSeccionYArea);

                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);


                        // Create chart
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/
                        let chart = rootTemp.container.children.push(am5xy.XYChart.new(rootTemp, {
                            panX: false,
                            panY: false,
                            wheelX: "panX",
                            wheelY: "zoomX",
                            layout: rootTemp.verticalLayout
                        }));


                        // Add legend
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
                        let legend = chart.children.push(
                            am5.Legend.new(rootTemp, {
                                centerX: am5.p50,
                                x: am5.p50
                            })
                        );

                        let data = [{
                            "year": "1 - UN ARÁNDANO",
                            "europe": 2,
                            "namerica": 1,
                            "asia": 2.1,
                            "lamerica": 1,
                            "meast": 0.8,
                            "africa": 0.4
                        }, {
                            "year": "3 - PRODUCCIÓN",
                            "europe": 4,
                            "namerica": 1,
                            "asia": 2.2,
                            "lamerica": 0.5,
                            "meast": 0.4,
                            "africa": 0.3
                        }]


                        // Create axes
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
                        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(rootTemp, {
                            categoryField: "year",
                            renderer: am5xy.AxisRendererX.new(rootTemp, {
                                cellStartLocation: 0.1,
                                cellEndLocation: 0.9
                            }),
                            tooltip: am5.Tooltip.new(rootTemp, {})
                        }));

                        xAxis.data.setAll(data);

                        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(rootTemp, {
                            renderer: am5xy.AxisRendererY.new(rootTemp, {})
                        }));


                        // Add series
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
                        function makeSeries(name, fieldName) {
                            let series = chart.series.push(am5xy.ColumnSeries.new(rootTemp, {
                                name: name,
                                xAxis: xAxis,
                                yAxis: yAxis,
                                valueYField: fieldName,
                                categoryXField: "year"
                            }));

                            series.columns.template.setAll({
                                tooltipText: "{name}, {categoryX}:{valueY}",
                                width: am5.percent(90),
                                tooltipY: 0
                            });

                            series.set("fill", am5.color("#134D25"));
                            series.set("stroke", am5.color("#134D25"));

                            // Add Label bullet
                            series.bullets.push(function () {
                                return am5.Bullet.new(rootTemp, {
                                    locationY: 1,
                                    sprite: am5.Label.new(rootTemp, {
                                    text: "{valueYWorking.formatNumber('#.')}",
                                    fill: rootTemp.interfaceColors.get("alternativeText"),
                                    centerY: 0,
                                    centerX: am5.p50,
                                    populateText: true
                                    })
                                });
                            });

                            series.data.setAll(data);

                            // Make stuff animate on load
                            // https://www.amcharts.com/docs/v5/concepts/animations/
                            series.appear();

                            series.bullets.push(function () {
                                return am5.Bullet.new(rootTemp, {
                                    locationY: 0,
                                    sprite: am5.Label.new(rootTemp, {
                                        text: "{valueY}",
                                        fill: rootTemp.interfaceColors.get("alternativeText"),
                                        centerY: 0,
                                        centerX: am5.p50,
                                        populateText: true
                                    })
                                });
                            });

                            legend.data.push(series);
                        }

                        makeSeries("4 - UN ARÁNDANO", "europe");
                        makeSeries("7 - PACKING", "namerica");
                        /*makeSeries("Asia", "asia");
                        makeSeries("Latin America", "lamerica");
                        makeSeries("Middle East", "meast");
                        makeSeries("Africa", "africa");*/

                        chart.set(
                            "scrollbarX",
                            am5.Scrollbar.new(rootTemp, {
                                orientation: "horizontal"
                            })
                        );

                        // Make stuff animate on load
                        // https://www.amcharts.com/docs/v5/concepts/animations/
                        chart.appear(1000, 100);

                        rootTemp._logo.dispose();
                        this.rootGraficoCantTrabSancionadosXSeccionYArea = rootTemp;
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionados");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },
        graficoCantTrabSancionadosXTipoSancion() {
            if (this.rootGraficoCantTrabSancionadosXTipoSancion !== "") {
                this.rootGraficoCantTrabSancionadosXTipoSancion = [];
            }
            //this.dataGraficoCantTrabSancionados = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancxtrab/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        //this.dataGraficoCantTrabSancionados = response.data.response;

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresSancXTipoSancion);


                        // Set themes
                        // https://www.amcharts.com/docs/v5/concepts/themes/
                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);


                        // Create chart
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/
                        let chart = rootTemp.container.children.push(am5xy.XYChart.new(rootTemp, {
                            panX: true,
                            panY: true,
                            wheelX: "panX",
                            wheelY: "zoomX",
                            pinchZoomX: true
                        }));

                        // Add cursor
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
                        let cursor = chart.set("cursor", am5xy.XYCursor.new(rootTemp, {}));
                        cursor.lineY.set("visible", false);


                        // Create axes
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
                        let xRenderer = am5xy.AxisRendererX.new(rootTemp, { minGridDistance: 30 });
                        xRenderer.labels.template.setAll({
                            rotation: -90,
                            centerY: am5.p50,
                            centerX: am5.p100,
                            paddingRight: 15
                        });

                        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(rootTemp, {
                            maxDeviation: 0.3,
                            categoryField: "country",
                            renderer: xRenderer,
                            tooltip: am5.Tooltip.new(rootTemp, {})
                        }));

                        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(rootTemp, {
                            maxDeviation: 0.3,
                            renderer: am5xy.AxisRendererY.new(rootTemp, {})
                        }));


                        // Create series
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
                        let series = chart.series.push(am5xy.ColumnSeries.new(rootTemp, {
                            name: "Series 1",
                            xAxis: xAxis,
                            yAxis: yAxis,
                            valueYField: "value",
                            sequencedInterpolation: true,
                            categoryXField: "country",
                            tooltip: am5.Tooltip.new(rootTemp, {
                                labelText: "{valueY}"
                            })
                        }));

                        series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5 });
                        series.set("fill", am5.color("#134D25"));
                        series.set("stroke", am5.color("#134D25"));

                        // Add Label bullet
                        series.bullets.push(function () {
                            return am5.Bullet.new(rootTemp, {
                                locationY: 1,
                                sprite: am5.Label.new(rootTemp, {
                                text: "{valueYWorking.formatNumber('#.')}",
                                fill: rootTemp.interfaceColors.get("alternativeText"),
                                centerY: 0,
                                centerX: am5.p50,
                                populateText: true
                                })
                            });
                        });

                        chart.set(
                            "scrollbarX",
                            am5.Scrollbar.new(rootTemp, {
                                orientation: "horizontal"
                            })
                        );


                        // Set data
                        let data = [{
                            country: "Amonestacion Escrita",
                            value: 2
                        }, {
                            country: "Despido",
                            value: 2
                        }, {
                            country: "Evaluable",
                            value: 2
                        }, {
                            country: "No Sancionado",
                            value: 1
                        }, {
                            country: "Amo. Verbal y/o Cta. Inductiva",
                            value: 1
                        }];

                        xAxis.data.setAll(data);
                        series.data.setAll(data);


                        // Make stuff animate on load
                        // https://www.amcharts.com/docs/v5/concepts/animations/
                        series.appear(1000);
                        chart.appear(1000, 100);

                        rootTemp._logo.dispose();
                        this.rootGraficoCantTrabSancionadosXTipoSancion = rootTemp;
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionados");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },
        graficoCantTrabSancionadosXTipoSancionXDepartamento() {
            if (this.rootGraficoCantTrabSancionadosXTipoSancionXDepartamento !== "") {
                this.rootGraficoCantTrabSancionadosXTipoSancionXDepartamento = [];
            }
            //this.dataGraficoCantTrabSancionados = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancxtrab/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        //this.dataGraficoCantTrabSancionados = response.data.response;

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresSancXTipoSancionXDepartamento);

                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);


                        // Create chart
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/
                        let chart = rootTemp.container.children.push(am5xy.XYChart.new(rootTemp, {
                            panX: false,
                            panY: false,
                            wheelX: "panX",
                            wheelY: "zoomX",
                            layout: rootTemp.verticalLayout
                        }));


                        // Add legend
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
                        let legend = chart.children.push(
                            am5.Legend.new(rootTemp, {
                                centerX: am5.p50,
                                x: am5.p50
                            })
                        );

                        let data = [{
                            "year": "9 - OPERACIONES AGRÍCOLAS",
                            "europe": 2,
                            "namerica": 1,
                            "asia": 2.1,
                            "lamerica": 1,
                            "meast": 0.8,
                            "africa": 0.4
                        }, {
                            "year": "6 - INNOVACIÓN Y NUEVOS NEGOCIOS",
                            "europe": 4,
                            "namerica": 1,
                            "asia": 2.2,
                            "lamerica": 0.5,
                            "meast": 0.4,
                            "africa": 0.3
                        }]


                        // Create axes
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
                        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(rootTemp, {
                            categoryField: "year",
                            renderer: am5xy.AxisRendererX.new(rootTemp, {
                                cellStartLocation: 0.1,
                                cellEndLocation: 0.9
                            }),
                            tooltip: am5.Tooltip.new(rootTemp, {})
                        }));

                        xAxis.data.setAll(data);

                        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(rootTemp, {
                            renderer: am5xy.AxisRendererY.new(rootTemp, {})
                        }));


                        // Add series
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
                        function makeSeries(name, fieldName) {
                            let series = chart.series.push(am5xy.ColumnSeries.new(rootTemp, {
                                name: name,
                                xAxis: xAxis,
                                yAxis: yAxis,
                                valueYField: fieldName,
                                categoryXField: "year"
                            }));

                            series.columns.template.setAll({
                                tooltipText: "{name}, {categoryX}:{valueY}",
                                width: am5.percent(90),
                                tooltipY: 0
                            });

                            series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5 });

                            series.set("fill", am5.color("#134D25"));
                            series.set("stroke", am5.color("#134D25"));

                            // Add Label bullet
                            series.bullets.push(function () {
                                return am5.Bullet.new(rootTemp, {
                                    locationY: 1,
                                    sprite: am5.Label.new(rootTemp, {
                                    text: "{valueYWorking.formatNumber('#.')}",
                                    fill: rootTemp.interfaceColors.get("alternativeText"),
                                    centerY: 0,
                                    centerX: am5.p50,
                                    populateText: true
                                    })
                                });
                            });

                            series.data.setAll(data);

                            // Make stuff animate on load
                            // https://www.amcharts.com/docs/v5/concepts/animations/
                            series.appear();



                            chart.set(
                                "scrollbarX",
                                am5.Scrollbar.new(rootTemp, {
                                    orientation: "horizontal"
                                })
                            );

                            legend.data.push(series);
                        }

                        makeSeries("Amonestacion Escrita", "europe");
                        makeSeries("Amo. Verbal y/o Cta. Inductiva", "namerica");
                        /*makeSeries("Asia", "asia");
                        makeSeries("Latin America", "lamerica");
                        makeSeries("Middle East", "meast");
                        makeSeries("Africa", "africa");*/


                        // Make stuff animate on load
                        // https://www.amcharts.com/docs/v5/concepts/animations/
                        chart.appear(1000, 100);

                        rootTemp._logo.dispose();
                        this.rootGraficoCantTrabSancionadosXTipoSancionXDepartamento = rootTemp;
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionados");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },
        graficoCantTrabAmonestadosXMotivo() {
            if (this.rootGraficoCantTrabAmonestadosXMotivo !== "") {
                this.rootGraficoCantTrabAmonestadosXMotivo = [];
            }
            //this.dataGraficoCantTrabSancionados = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancxtrab/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        //this.dataGraficoCantTrabSancionados = response.data.response;

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresAmonXMotivo);


                        // Set themes
                        // https://www.amcharts.com/docs/v5/concepts/themes/
                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);


                        // Create chart
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/
                        let chart = rootTemp.container.children.push(am5xy.XYChart.new(rootTemp, {
                            panX: true,
                            panY: true,
                            wheelX: "panX",
                            wheelY: "zoomX",
                            pinchZoomX: true
                        }));

                        // Add cursor
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
                        let cursor = chart.set("cursor", am5xy.XYCursor.new(rootTemp, {}));
                        cursor.lineY.set("visible", false);


                        // Create axes
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
                        let xRenderer = am5xy.AxisRendererX.new(rootTemp, { minGridDistance: 30 });
                        xRenderer.labels.template.setAll({
                            rotation: -90,
                            centerY: am5.p50,
                            centerX: am5.p100,
                            paddingRight: 15
                        });

                        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(rootTemp, {
                            maxDeviation: 0.3,
                            categoryField: "country",
                            renderer: xRenderer,
                            tooltip: am5.Tooltip.new(rootTemp, {})
                        }));

                        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(rootTemp, {
                            maxDeviation: 0.3,
                            renderer: am5xy.AxisRendererY.new(rootTemp, {})
                        }));


                        // Create series
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
                        let series = chart.series.push(am5xy.ColumnSeries.new(rootTemp, {
                            name: "Series 1",
                            xAxis: xAxis,
                            yAxis: yAxis,
                            valueYField: "value",
                            sequencedInterpolation: true,
                            categoryXField: "country",
                            tooltip: am5.Tooltip.new(rootTemp, {
                                labelText: "{valueY}"
                            })
                        }));

                        series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5 });
                        series.set("fill", am5.color("#134D25"));
                        series.set("stroke", am5.color("#134D25"));

                        // Add Label bullet
                        series.bullets.push(function () {
                            return am5.Bullet.new(rootTemp, {
                                locationY: 1,
                                sprite: am5.Label.new(rootTemp, {
                                text: "{valueYWorking.formatNumber('#.')}",
                                fill: rootTemp.interfaceColors.get("alternativeText"),
                                centerY: 0,
                                centerX: am5.p50,
                                populateText: true
                                })
                            });
                        });

                        chart.set(
                            "scrollbarX",
                            am5.Scrollbar.new(rootTemp, {
                                orientation: "horizontal"
                            })
                        );

                        // Set data
                        let data = [{
                            country: "Conducta personal",
                            value: 2
                        }, {
                            country: "Actitud en el trabajo",
                            value: 2
                        }, {
                            country: "Insubordinación",
                            value: 2
                        }];

                        xAxis.data.setAll(data);
                        series.data.setAll(data);


                        // Make stuff animate on load
                        // https://www.amcharts.com/docs/v5/concepts/animations/
                        series.appear(1000);
                        chart.appear(1000, 100);

                        rootTemp._logo.dispose();
                        this.rootGraficoCantTrabAmonestadosXMotivo = rootTemp;
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionados");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },
        graficoCantTrabAmonestadosXDepartamentoXMotivo() {
            if (this.rootGraficoCantTrabAmonestadosXDepartamentoXMotivo !== "") {
                this.rootGraficoCantTrabAmonestadosXDepartamentoXMotivo = [];
            }
            //this.dataGraficoCantTrabSancionados = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancxtrab/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        //this.dataGraficoCantTrabSancionados = response.data.response;

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresAmonXDepartamentoXMotivo);

                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);


                        // Create chart
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/
                        let chart = rootTemp.container.children.push(am5xy.XYChart.new(rootTemp, {
                            panX: false,
                            panY: false,
                            wheelX: "panX",
                            wheelY: "zoomX",
                            layout: rootTemp.verticalLayout
                        }));


                        // Add legend
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
                        let legend = chart.children.push(
                            am5.Legend.new(rootTemp, {
                                centerX: am5.p50,
                                x: am5.p50
                            })
                        );

                        let data = [{
                            "year": "Conducta personal",
                            "europe": 2,
                            "namerica": 1,
                            "asia": 2.1,
                            "lamerica": 1,
                            "meast": 0.8,
                            "africa": 0.4
                        }, {
                            "year": "Actitud en el trabajo",
                            "europe": 4,
                            "namerica": 1,
                            "asia": 2.2,
                            "lamerica": 0.5,
                            "meast": 0.4,
                            "africa": 0.3
                        }]


                        // Create axes
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
                        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(rootTemp, {
                            categoryField: "year",
                            renderer: am5xy.AxisRendererX.new(rootTemp, {
                                cellStartLocation: 0.1,
                                cellEndLocation: 0.9
                            }),
                            tooltip: am5.Tooltip.new(rootTemp, {})
                        }));

                        xAxis.data.setAll(data);

                        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(rootTemp, {
                            renderer: am5xy.AxisRendererY.new(rootTemp, {})
                        }));


                        // Add series
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
                        function makeSeries(name, fieldName) {
                            let series = chart.series.push(am5xy.ColumnSeries.new(rootTemp, {
                                name: name,
                                xAxis: xAxis,
                                yAxis: yAxis,
                                valueYField: fieldName,
                                categoryXField: "year"
                            }));

                            series.columns.template.setAll({
                                tooltipText: "{name}, {categoryX}:{valueY}",
                                width: am5.percent(90),
                                tooltipY: 0
                            });

                            series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5 });

                            series.set("fill", am5.color("#134D25"));
                            series.set("stroke", am5.color("#134D25"));

                            // Add Label bullet
                            series.bullets.push(function () {
                                return am5.Bullet.new(rootTemp, {
                                    locationY: 1,
                                    sprite: am5.Label.new(rootTemp, {
                                    text: "{valueYWorking.formatNumber('#.')}",
                                    fill: rootTemp.interfaceColors.get("alternativeText"),
                                    centerY: 0,
                                    centerX: am5.p50,
                                    populateText: true
                                    })
                                });
                            });

                            chart.set(
                                "scrollbarX",
                                am5.Scrollbar.new(rootTemp, {
                                    orientation: "horizontal"
                                })
                            );

                            series.data.setAll(data);

                            // Make stuff animate on load
                            // https://www.amcharts.com/docs/v5/concepts/animations/
                            series.appear();

                            legend.data.push(series);
                        }

                        makeSeries("9 - OPERACIONES AGRÍCOLAS", "europe");
                        makeSeries("6 - INNOVACIÓN Y NUEVOS NEGOCIOS", "namerica");
                        /*makeSeries("Asia", "asia");
                        makeSeries("Latin America", "lamerica");
                        makeSeries("Middle East", "meast");
                        makeSeries("Africa", "africa");*/


                        // Make stuff animate on load
                        // https://www.amcharts.com/docs/v5/concepts/animations/
                        chart.appear(1000, 100);

                        rootTemp._logo.dispose();
                        this.rootGraficoCantTrabAmonestadosXDepartamentoXMotivo = rootTemp;
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionados");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },
        graficoCantTrabSuspendidosXMotivo() {
            if (this.rootGraficoCantTrabSuspendidosXMotivo !== "") {
                this.rootGraficoCantTrabSuspendidosXMotivo = [];
            }
            //this.dataGraficoCantTrabSancionados = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancxtrab/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        //this.dataGraficoCantTrabSancionados = response.data.response;

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresSuspXMotivo);


                        // Set themes
                        // https://www.amcharts.com/docs/v5/concepts/themes/
                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);


                        // Create chart
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/
                        let chart = rootTemp.container.children.push(am5xy.XYChart.new(rootTemp, {
                            panX: true,
                            panY: true,
                            wheelX: "panX",
                            wheelY: "zoomX",
                            pinchZoomX: true
                        }));

                        // Add cursor
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
                        let cursor = chart.set("cursor", am5xy.XYCursor.new(rootTemp, {}));
                        cursor.lineY.set("visible", false);


                        // Create axes
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
                        let xRenderer = am5xy.AxisRendererX.new(rootTemp, { minGridDistance: 30 });
                        xRenderer.labels.template.setAll({
                            rotation: -90,
                            centerY: am5.p50,
                            centerX: am5.p100,
                            paddingRight: 15
                        });

                        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(rootTemp, {
                            maxDeviation: 0.3,
                            categoryField: "country",
                            renderer: xRenderer,
                            tooltip: am5.Tooltip.new(rootTemp, {})
                        }));

                        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(rootTemp, {
                            maxDeviation: 0.3,
                            renderer: am5xy.AxisRendererY.new(rootTemp, {})
                        }));


                        // Create series
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
                        let series = chart.series.push(am5xy.ColumnSeries.new(rootTemp, {
                            name: "Series 1",
                            xAxis: xAxis,
                            yAxis: yAxis,
                            valueYField: "value",
                            sequencedInterpolation: true,
                            categoryXField: "country",
                            tooltip: am5.Tooltip.new(rootTemp, {
                                labelText: "{valueY}"
                            })
                        }));

                        series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5 });
                        series.set("fill", am5.color("#134D25"));
                        series.set("stroke", am5.color("#134D25"));

                        // Add Label bullet
                        series.bullets.push(function () {
                            return am5.Bullet.new(rootTemp, {
                                locationY: 1,
                                sprite: am5.Label.new(rootTemp, {
                                text: "{valueYWorking.formatNumber('#.')}",
                                fill: rootTemp.interfaceColors.get("alternativeText"),
                                centerY: 0,
                                centerX: am5.p50,
                                populateText: true
                                })
                            });
                        });

                        chart.set(
                            "scrollbarX",
                            am5.Scrollbar.new(rootTemp, {
                                orientation: "horizontal"
                            })
                        );

                        // Set data
                        let data = [{
                            country: "Conducta personal",
                            value: 4
                        }, {
                            country: "Actitud en el trabajo",
                            value: 3
                        }, {
                            country: "Insubordinación",
                            value: 1
                        }];

                        xAxis.data.setAll(data);
                        series.data.setAll(data);


                        // Make stuff animate on load
                        // https://www.amcharts.com/docs/v5/concepts/animations/
                        series.appear(1000);
                        chart.appear(1000, 100);

                        rootTemp._logo.dispose();
                        this.rootGraficoCantTrabSuspendidosXMotivo = rootTemp;
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionados");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },
        graficoCantTrabSuspendidosXDepartamentoXMotivo() {
            if (this.rootGraficoCantTrabSuspendidosXDepartamentoXMotivo !== "") {
                this.rootGraficoCantTrabSuspendidosXDepartamentoXMotivo = []
            }
            //this.dataGraficoCantTrabSancionados = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancxtrab/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        //this.dataGraficoCantTrabSancionados = response.data.response;

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresSuspXDepartamentoXMotivo);

                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);


                        // Create chart
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/
                        let chart = rootTemp.container.children.push(am5xy.XYChart.new(rootTemp, {
                            panX: false,
                            panY: false,
                            wheelX: "panX",
                            wheelY: "zoomX",
                            layout: rootTemp.verticalLayout
                        }));


                        // Add legend
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
                        let legend = chart.children.push(
                            am5.Legend.new(rootTemp, {
                                centerX: am5.p50,
                                x: am5.p50
                            })
                        );

                        let data = [{
                            "year": "Conducta personal",
                            "europe": 3,
                            "namerica": 2,
                            "asia": 2.1,
                            "lamerica": 1,
                            "meast": 0.8,
                            "africa": 0.4
                        }, {
                            "year": "Actitud en el trabajo",
                            "europe": 4,
                            "namerica": 1,
                            "asia": 2.2,
                            "lamerica": 0.5,
                            "meast": 0.4,
                            "africa": 0.3
                        }]


                        // Create axes
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
                        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(rootTemp, {
                            categoryField: "year",
                            renderer: am5xy.AxisRendererX.new(rootTemp, {
                                cellStartLocation: 0.1,
                                cellEndLocation: 0.9
                            }),
                            tooltip: am5.Tooltip.new(rootTemp, {})
                        }));

                        xAxis.data.setAll(data);

                        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(rootTemp, {
                            renderer: am5xy.AxisRendererY.new(rootTemp, {})
                        }));


                        // Add series
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
                        function makeSeries(name, fieldName) {
                            let series = chart.series.push(am5xy.ColumnSeries.new(rootTemp, {
                                name: name,
                                xAxis: xAxis,
                                yAxis: yAxis,
                                valueYField: fieldName,
                                categoryXField: "year"
                            }));

                            series.columns.template.setAll({
                                tooltipText: "{name}, {categoryX}:{valueY}",
                                width: am5.percent(90),
                                tooltipY: 0
                            });
                            series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5 });

                            series.set("fill", am5.color("#134D25"));
                            series.set("stroke", am5.color("#134D25"));

                            // Add Label bullet
                            series.bullets.push(function () {
                                return am5.Bullet.new(rootTemp, {
                                    locationY: 1,
                                    sprite: am5.Label.new(rootTemp, {
                                    text: "{valueYWorking.formatNumber('#.')}",
                                    fill: rootTemp.interfaceColors.get("alternativeText"),
                                    centerY: 0,
                                    centerX: am5.p50,
                                    populateText: true
                                    })
                                });
                            });

                            chart.set(
                                "scrollbarX",
                                am5.Scrollbar.new(rootTemp, {
                                    orientation: "horizontal"
                                })
                            );

                            series.data.setAll(data);

                            // Make stuff animate on load
                            // https://www.amcharts.com/docs/v5/concepts/animations/
                            series.appear();

                            legend.data.push(series);
                        }

                        makeSeries("9 - OPERACIONES AGRÍCOLAS", "europe");
                        makeSeries("6 - INNOVACIÓN Y NUEVOS NEGOCIOS", "namerica");
                        /*makeSeries("Asia", "asia");
                        makeSeries("Latin America", "lamerica");
                        makeSeries("Middle East", "meast");
                        makeSeries("Africa", "africa");*/


                        // Make stuff animate on load
                        // https://www.amcharts.com/docs/v5/concepts/animations/
                        chart.appear(1000, 100);

                        rootTemp._logo.dispose();
                        this.rootGraficoCantTrabSuspendidosXDepartamentoXMotivo = rootTemp;
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionados");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },
        graficoCantTrabAmonestadosXMotivoXSemana() {
            if (this.rootGraficoCantTrabAmonestadosXMotivoXSemana !== "") {
                this.rootGraficoCantTrabAmonestadosXMotivoXSemana = []
            }
            //this.dataGraficoCantTrabSancionados = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancxtrab/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        //this.dataGraficoCantTrabSancionados = response.data.response;

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresAmonXMotivoXSem);

                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);

                        let chart = rootTemp.container.children.push(
                            am5xy.XYChart.new(rootTemp, {
                                panX: false,
                                panY: false,
                                wheelX: "none",
                                wheelY: "none"
                            })
                        );

                        let cursor = chart.set("cursor", am5xy.XYCursor.new(rootTemp, {}));
                        cursor.lineY.set("visible", false);

                        let xRenderer = am5xy.AxisRendererX.new(rootTemp, { minGridDistance: 30 });
                        xRenderer.labels.template.setAll({ text: "{realName}" });

                        let xAxis = chart.xAxes.push(
                            am5xy.CategoryAxis.new(rootTemp, {
                                maxDeviation: 0,
                                categoryField: "category",
                                renderer: xRenderer,
                                tooltip: am5.Tooltip.new(rootTemp, {
                                    labelText: "{realName}"
                                })
                            })
                        );

                        let yAxis = chart.yAxes.push(
                            am5xy.ValueAxis.new(rootTemp, {
                                maxDeviation: 0.3,
                                renderer: am5xy.AxisRendererY.new(rootTemp, {})
                            })
                        );

                        let yAxis2 = chart.yAxes.push(
                            am5xy.ValueAxis.new(rootTemp, {
                                maxDeviation: 0.3,
                                syncWithAxis: yAxis,
                                renderer: am5xy.AxisRendererY.new(rootTemp, { opposite: true })
                            })
                        );

                        let series = chart.series.push(
                            am5xy.ColumnSeries.new(rootTemp, {
                                name: "Series 1",
                                xAxis: xAxis,
                                yAxis: yAxis2,
                                valueYField: "value",
                                sequencedInterpolation: true,
                                categoryXField: "category",
                                tooltip: am5.Tooltip.new(rootTemp, {
                                    labelText: "{provider} {realName}: {valueY}"
                                })
                            })
                        );

                        series.columns.template.setAll({
                            fillOpacity: 0.9,
                            strokeOpacity: 0
                        });

                        series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5 });

                        series.set("fill", am5.color("#134D25"));
                        series.set("stroke", am5.color("#134D25"));

                        // Add Label bullet
                        series.bullets.push(function () {
                            return am5.Bullet.new(rootTemp, {
                                locationY: 1,
                                sprite: am5.Label.new(rootTemp, {
                                text: "{valueYWorking.formatNumber('#.')}",
                                fill: rootTemp.interfaceColors.get("alternativeText"),
                                centerY: 0,
                                centerX: am5.p50,
                                populateText: true
                                })
                            });
                        });

                        chart.set(
                            "scrollbarX",
                            am5.Scrollbar.new(rootTemp, {
                                orientation: "horizontal"
                            })
                        );

                        let chartData = [];

                        let data = {
                            "1": {
                                "Conducta personal": 2
                            },
                            "10": {
                                "Insubordinación": 15
                            },
                            "20": {
                                "Actitud en el trabajo": 1,
                                "SST": 3
                            },
                            "45": {
                                "Conducta personal": 1
                            }
                        };



                        for (let providerName in data) {
                            let providerData = data[providerName];

                            let tempArray = [];

                            for (let itemName in providerData) {
                                tempArray.push({
                                    category: providerName + "_" + itemName,
                                    realName: itemName,
                                    value: providerData[itemName],
                                    provider: providerName
                                });
                            }



                            am5.array.each(tempArray, function (item) {
                                chartData.push(item);
                            });

                            let range = xAxis.makeDataItem({});
                            xAxis.createAxisRange(range);

                            range.set("category", tempArray[0].category);
                            range.set("endCategory", tempArray[tempArray.length - 1].category);

                            let label = range.get("label");

                            label.setAll({
                                text: tempArray[0].provider,
                                dy: 30,
                                fontWeight: "bold",
                                tooltipText: tempArray[0].provider
                            });

                            let tick = range.get("tick");
                            tick.setAll({ visible: true, strokeOpacity: 1, length: 50, location: 0 });

                            let grid = range.get("grid");
                            grid.setAll({ strokeOpacity: 1 });
                        }

                        // add range for the last grid
                        let range = xAxis.makeDataItem({});
                        xAxis.createAxisRange(range);
                        range.set("category", chartData[chartData.length - 1].category);
                        let tick = range.get("tick");
                        tick.setAll({ visible: true, strokeOpacity: 1, length: 50, location: 1 });

                        let grid = range.get("grid");
                        grid.setAll({ strokeOpacity: 1, location: 1 });

                        xAxis.data.setAll(chartData);
                        series.data.setAll(chartData);

                        // Make stuff animate on load
                        // https://www.amcharts.com/docs/v5/concepts/animations/
                        series.appear(1000);
                        chart.appear(1000, 100);

                        rootTemp._logo.dispose();
                        this.rootGraficoCantTrabAmonestadosXMotivoXSemana = rootTemp;
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionados");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },
        graficoCantTrabSuspendidosXMotivoXSemana() {
            if (this.rootGraficoCantTrabSuspendidosXMotivoXSemana !== "") {
                this.rootGraficoCantTrabSuspendidosXMotivoXSemana = []
            }
            //this.dataGraficoCantTrabSancionados = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancxtrab/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        //this.dataGraficoCantTrabSancionados = response.data.response;

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresSuspXMotivoXSem);

                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);

                        let chart = rootTemp.container.children.push(
                            am5xy.XYChart.new(rootTemp, {
                                panX: false,
                                panY: false,
                                wheelX: "none",
                                wheelY: "none"
                            })
                        );

                        let cursor = chart.set("cursor", am5xy.XYCursor.new(rootTemp, {}));
                        cursor.lineY.set("visible", false);

                        let xRenderer = am5xy.AxisRendererX.new(rootTemp, { minGridDistance: 30 });
                        xRenderer.labels.template.setAll({ text: "{realName}" });

                        let xAxis = chart.xAxes.push(
                            am5xy.CategoryAxis.new(rootTemp, {
                                maxDeviation: 0,
                                categoryField: "category",
                                renderer: xRenderer,
                                tooltip: am5.Tooltip.new(rootTemp, {
                                    labelText: "{realName}"
                                })
                            })
                        );

                        let yAxis = chart.yAxes.push(
                            am5xy.ValueAxis.new(rootTemp, {
                                maxDeviation: 0.3,
                                renderer: am5xy.AxisRendererY.new(rootTemp, {})
                            })
                        );

                        let yAxis2 = chart.yAxes.push(
                            am5xy.ValueAxis.new(rootTemp, {
                                maxDeviation: 0.3,
                                syncWithAxis: yAxis,
                                renderer: am5xy.AxisRendererY.new(rootTemp, { opposite: true })
                            })
                        );

                        let series = chart.series.push(
                            am5xy.ColumnSeries.new(rootTemp, {
                                name: "Series 1",
                                xAxis: xAxis,
                                yAxis: yAxis2,
                                valueYField: "value",
                                sequencedInterpolation: true,
                                categoryXField: "category",
                                tooltip: am5.Tooltip.new(rootTemp, {
                                    labelText: "{provider} {realName}: {valueY}"
                                })
                            })
                        );

                        series.columns.template.setAll({
                            fillOpacity: 0.9,
                            strokeOpacity: 0
                        });

                        series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5 });

                        series.set("fill", am5.color("#134D25"));
                        series.set("stroke", am5.color("#134D25"));

                        // Add Label bullet
                        series.bullets.push(function () {
                            return am5.Bullet.new(rootTemp, {
                                locationY: 1,
                                sprite: am5.Label.new(rootTemp, {
                                text: "{valueYWorking.formatNumber('#.')}",
                                fill: rootTemp.interfaceColors.get("alternativeText"),
                                centerY: 0,
                                centerX: am5.p50,
                                populateText: true
                                })
                            });
                        });

                        chart.set(
                            "scrollbarX",
                            am5.Scrollbar.new(rootTemp, {
                                orientation: "horizontal"
                            })
                        );

                        let chartData = [];

                        let data = {
                            "1": {
                                "Conducta personal": 7
                            },
                            "10": {
                                "Insubordinación": 4
                            },
                            "20": {
                                "Actitud en el trabajo": 10,
                                "SST": 3
                            },
                            "45": {
                                "Conducta personal": 15
                            }
                        };



                        for (let providerName in data) {
                            let providerData = data[providerName];

                            let tempArray = [];

                            for (let itemName in providerData) {
                                tempArray.push({
                                    category: providerName + "_" + itemName,
                                    realName: itemName,
                                    value: providerData[itemName],
                                    provider: providerName
                                });
                            }



                            am5.array.each(tempArray, function (item) {
                                chartData.push(item);
                            });

                            let range = xAxis.makeDataItem({});
                            xAxis.createAxisRange(range);

                            range.set("category", tempArray[0].category);
                            range.set("endCategory", tempArray[tempArray.length - 1].category);

                            let label = range.get("label");

                            label.setAll({
                                text: tempArray[0].provider,
                                dy: 30,
                                fontWeight: "bold",
                                tooltipText: tempArray[0].provider
                            });

                            let tick = range.get("tick");
                            tick.setAll({ visible: true, strokeOpacity: 1, length: 50, location: 0 });

                            let grid = range.get("grid");
                            grid.setAll({ strokeOpacity: 1 });
                        }

                        // add range for the last grid
                        let range = xAxis.makeDataItem({});
                        xAxis.createAxisRange(range);
                        range.set("category", chartData[chartData.length - 1].category);
                        let tick = range.get("tick");
                        tick.setAll({ visible: true, strokeOpacity: 1, length: 50, location: 1 });

                        let grid = range.get("grid");
                        grid.setAll({ strokeOpacity: 1, location: 1 });

                        xAxis.data.setAll(chartData);
                        series.data.setAll(chartData);

                        // Make stuff animate on load
                        // https://www.amcharts.com/docs/v5/concepts/animations/
                        series.appear(1000);
                        chart.appear(1000, 100);

                        rootTemp._logo.dispose();
                        this.rootGraficoCantTrabSuspendidosXMotivoXSemana = rootTemp;
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionados");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },
        graficoCantTrabSuspendidosXUsuarioReporta() {
            if (this.rootGraficoCantTrabSuspendidosXUsuarioReporta !== "") {
                this.rootGraficoCantTrabSuspendidosXUsuarioReporta = []
            }
            //this.dataGraficoCantTrabSancionados = [];

          const FormData = require('form-data')
          const datafiltro = new FormData()
          datafiltro.append('fecha_inicio', this.txtFechaDesde);
            datafiltro.append('fecha_fin', this.txtFechaHasta);
            datafiltro.append('empresa', this.selectedEmpresa);
            datafiltro.append('cultivo', this.selectedCultivo);
            datafiltro.append('fundo', this.selectedFundo);
            datafiltro.append('lugar', this.selectedLugar);
            datafiltro.append('categoria_id', this.selectedCategoria);
            datafiltro.append('ultimo_estado_sancion_id', this.selectedEstado);

          const config = {
            method: 'post',
            url: '/sap/md/mdsancion/cantsancxtrab/',
            data: datafiltro
          }

          axiosIns(config)
                .then((response) => {
                    if (response.status === 200) {
                        //this.dataGraficoCantTrabSancionados = response.data.response;

                        let rootTemp = am5.Root.new(this.$refs.cantTrabajadoresSancXUsuarioReporta);

                        rootTemp.setThemes([
                            am5themes_Animated.new(rootTemp)
                        ]);


                        // Create chart
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/
                        let chart = rootTemp.container.children.push(am5xy.XYChart.new(rootTemp, {
                            panX: false,
                            panY: false,
                            wheelX: "panX",
                            wheelY: "zoomX",
                            layout: rootTemp.verticalLayout
                        }));


                        // Add legend
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
                        let legend = chart.children.push(
                            am5.Legend.new(rootTemp, {
                                centerX: am5.p50,
                                x: am5.p50
                            })
                        );

                        let data = [{
                            "year": "Juan Perez",
                            "europe": 2,
                            "namerica": 1,
                            "asia": 2.1,
                            "lamerica": 1,
                            "meast": 0.8,
                            "africa": 0.4
                        }, {
                            "year": "Luis Garcia",
                            "europe": 4,
                            "namerica": 1,
                            "asia": 2.2,
                            "lamerica": 0.5,
                            "meast": 0.4,
                            "africa": 0.3
                        }]


                        // Create axes
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
                        let xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(rootTemp, {
                            categoryField: "year",
                            renderer: am5xy.AxisRendererX.new(rootTemp, {
                                cellStartLocation: 0.1,
                                cellEndLocation: 0.9
                            }),
                            tooltip: am5.Tooltip.new(rootTemp, {})
                        }));

                        xAxis.data.setAll(data);

                        let yAxis = chart.yAxes.push(am5xy.ValueAxis.new(rootTemp, {
                            renderer: am5xy.AxisRendererY.new(rootTemp, {})
                        }));


                        // Add series
                        // https://www.amcharts.com/docs/v5/charts/xy-chart/series/
                        function makeSeries(name, fieldName) {
                            let series = chart.series.push(am5xy.ColumnSeries.new(rootTemp, {
                                name: name,
                                xAxis: xAxis,
                                yAxis: yAxis,
                                valueYField: fieldName,
                                categoryXField: "year"
                            }));

                            series.columns.template.setAll({
                                tooltipText: "{name}, {categoryX}:{valueY}",
                                width: am5.percent(90),
                                tooltipY: 0
                            });

                            series.columns.template.setAll({ cornerRadiusTL: 5, cornerRadiusTR: 5 });

                            series.set("fill", am5.color("#134D25"));
                            series.set("stroke", am5.color("#134D25"));

                            // Add Label bullet
                            series.bullets.push(function () {
                                return am5.Bullet.new(rootTemp, {
                                    locationY: 1,
                                    sprite: am5.Label.new(rootTemp, {
                                    text: "{valueYWorking.formatNumber('#.')}",
                                    fill: rootTemp.interfaceColors.get("alternativeText"),
                                    centerY: 0,
                                    centerX: am5.p50,
                                    populateText: true
                                    })
                                });
                            });

                            series.data.setAll(data);

                            // Make stuff animate on load
                            // https://www.amcharts.com/docs/v5/concepts/animations/
                            series.appear();

                            legend.data.push(series);
                        }

                        makeSeries("Amo. Verbal y/o Cta. Inductiva", "europe");
                        makeSeries("Amonestacion Escrita", "namerica");
                        /*makeSeries("Asia", "asia");
                        makeSeries("Latin America", "lamerica");
                        makeSeries("Middle East", "meast");
                        makeSeries("Africa", "africa");*/

                        chart.set(
                            "scrollbarX",
                            am5.Scrollbar.new(rootTemp, {
                                orientation: "horizontal"
                            })
                        );

                        // Make stuff animate on load
                        // https://www.amcharts.com/docs/v5/concepts/animations/
                        chart.appear(1000, 100);

                        rootTemp._logo.dispose();
                    }
                })
                .catch((error) => {
                    //console.log(error);
                    console.log("=======error======= graficoCantTrabSancionados");
                    //this.graficoCantTrabSancionados();
                })
                .finally(() => {
                    //this.cargandoSanciones = false;
                });


        },

    },
    created() {
        this.obtenerCategorias();
        this.obtenerEstados();
        this.obtenerEmpresa();
        this.obtenerZonas();
        this.graficoCantTrabSancionados();
    }
}

</script>
<style scoped>
.size_grafico {
    width: 100%;
    height: 400px;
}
</style>
